import { render, staticRenderFns } from "./UpdateBox.vue?vue&type=template&id=4ef88b9f"
import script from "./UpdateBox.vue?vue&type=script&lang=js"
export * from "./UpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports